import axios from '@/app/shared/config/interceptor'

import { Ability } from '@casl/ability'
import { TYPE_KEY } from '@/app/shared/services/utils'

const state = {
  rules: [],
  token: null,
  status: '',
  message: ''
}

// getters
const getters = {
  isAuthenticated: state => !!state.token,
  isClient: state => state.token == null ? false : state.token.c,
  isAuthenticatedInternal: state => state.token == null ? false : !!state.token && !state.token.c,
  authStatus: state => state.status,
  authErrorMessage: state => state.message,
  clientData: () => JSON.parse(window.atob(localStorage.c)),
  accessToken: state => {
    return state.token ? state.token.authToken : null
  },
  loggedUser: state => {
    return state.token ? state.token.fullName : null
  },
  loggedUserAsObj: state => {
    return state.token ? { fullName: state.token.fullName, initials: state.token.initials } : null
  },
  departments: state => {
    return state.token ? state.token.departments : null
  },
  isAdmin: state => {
    return state.token ? state.token.isAdmin : false
  },
  email: state => {
    return state.token ? state.token.email : null
  },
  ability () {
    return new Ability([], {
      subjectName (subject) {
        return !subject || typeof subject === 'string'
          ? subject
          : subject[TYPE_KEY]
      }
    })
  }
}

// actions
const actions = {
  login: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')

      axios.post('/security/authenticate', user)
        .then(resp => {
          if (resp.data.authenticated) {
            let token = { ...resp.data }
            token.rules = null
            commit('AUTH_SUCCESS', token)
            commit('CREATE_RULES', resp.data.rules)

            resolve(resp)
          } else {
            reject(resp.data)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  async clientAreaAcess ({ commit, dispatch }, params) {
    dispatch('destroySession')
    // new Promise((resolve, reject) => {
    commit('AUTH_REQUEST')

    await axios.post('/security/clientarea/access', params)
      .then(resp => {
        if (resp.data.authenticated) {
          let token = { ...resp.data }
          token.rules = null
          commit('AUTH_SUCCESS', token)
          commit('CREATE_RULES', resp.data.rules)

          // resolve(resp)
        } else {
          dispatch('destroySession')
          // reject(resp.data)
        }
      })
      // .catch(err => {
      //   // reject(err)
      // })
    // })
  },

  saveClientData ({ commit }, data) {
    localStorage.c = window.btoa(JSON.stringify(data))
  },

  createSession: ({ commit }, token) => {
    let newToken = { ...token }
    newToken.rules = null
    commit('AUTH_SUCCESS', newToken)
    commit('CREATE_RULES', token.rules)
  },

  destroySession: ({ commit }) => {
    commit('AUTH_CLEAR')
    commit('DESTROY_RULES')
  },

  logout: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_CLEAR')
      commit('DESTROY_RULES')
      resolve()
    })
  },

  authenticationError: ({ commit, dispatch }, error) => {
    commit('AUTH_ERROR')
    commit('AUTH_ERROR_MESSAGE', error)
  },

  changeUserName: ({ commit, dispatch }, fullName) => {
    return new Promise((resolve, reject) => {
      commit('SET_NAME', fullName)
      resolve()
    })
  },

  addDepartment: ({ commit }, newDepartment) => {
    return new Promise((resolve, reject) => {
      commit('ADD_DEPARTMENT', newDepartment)
      resolve()
    })
  }
}

// mutations
const mutations = {
  AUTH_REQUEST: (state) => {
    state.status = 'loading'
    state.message = ''
  },

  AUTH_SUCCESS: (state, token) => {
    state.status = 'success'
    state.token = token
    state.message = ''
  },

  AUTH_CLEAR: (state) => {
    state.status = null
    state.token = null
    state.message = null
  },

  AUTH_ERROR: (state) => {
    state.status = 'error'
  },

  AUTH_ERROR_MESSAGE: (state, message) => {
    state.message = message
  },

  SET_NAME: (state, fullName) => {
    var token = state.token ? state.token : null
    token.fullName = fullName
  },

  CREATE_RULES: (state, rules) => {
    state.rules = rules
  },

  DESTROY_RULES: (state) => {
    state.rules = []
  },

  REPLACE_STATE: (state, newState) => {
    state.rules = newState['auth/rules']
    state.token = newState['auth/token']
  },

  ADD_DEPARTMENT: (state, newDepartment) => {
    var token = state.token ? state.token : null
    token.departments += `;${newDepartment}`
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
